import { OnboardingRoutesWithProvider } from '@leagueplatform/onboarding';
import { TENANT_ID } from 'common/constants/constants';

type FeatureHighlightsProps = {
  onOnboardingComplete: () => void;
};

export function FeatureHighlights({
  onOnboardingComplete,
}: FeatureHighlightsProps) {
  return (
    <OnboardingRoutesWithProvider
      contentfulId={import.meta.env.VITE_ONBOARDING_CONTENTFUL_ID}
      tenantId={TENANT_ID}
      onOnboardingComplete={onOnboardingComplete}
    />
  );
}
